/* Fortryd aftale – formular i to trin mod Cloudflare Worker'en.
   Bruges af snippets/fortryd-aftale.liquid (dialog) og sections/fortryd-aftale.liquid (side). */
(function () {
  'use strict';

  if (window.__nvFortrydInit) return;
  window.__nvFortrydInit = true;

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var SUPPORT_MAIL = 'support@nerdvaerket.dk';

  function text(el, value) {
    if (el) el.textContent = value;
  }

  function fieldWrap(input) {
    return input ? input.closest('.nv-fortryd__field') : null;
  }

  function setError(input, message) {
    var wrap = fieldWrap(input);
    if (!wrap) return;
    var box = wrap.querySelector('[data-nv-error]');
    if (message) {
      input.setAttribute('aria-invalid', 'true');
      if (box) {
        box.textContent = message;
        box.hidden = false;
      }
    } else {
      input.removeAttribute('aria-invalid');
      if (box) {
        box.textContent = '';
        box.hidden = true;
      }
    }
  }

  function clearErrors(form) {
    form.querySelectorAll('[data-nv-field]').forEach(function (input) {
      setError(input, '');
    });
  }

  function validate(form) {
    var errors = [];
    var name = form.elements.namedItem('name');
    var order = form.elements.namedItem('orderNo');
    var email = form.elements.namedItem('email');
    var items = form.elements.namedItem('items');

    clearErrors(form);

    if (!name.value.trim() || name.value.trim().length < 2) {
      setError(name, 'Skriv dit navn.');
      errors.push(name);
    }
    if (!order.value.trim() || order.value.trim().length < 2) {
      setError(order, 'Skriv dit ordrenummer – det står i din ordrebekræftelse.');
      errors.push(order);
    }
    if (!EMAIL_RE.test(email.value.trim())) {
      setError(email, 'Skriv en e-mailadresse, vi kan sende kvitteringen til.');
      errors.push(email);
    }
    if (items.value.length > 500) {
      setError(items, 'Skriv højst 500 tegn.');
      errors.push(items);
    }

    return errors;
  }

  function summaryRows(form) {
    var rows = [
      ['Navn', form.elements.namedItem('name').value.trim()],
      ['Ordrenummer', form.elements.namedItem('orderNo').value.trim()],
      ['E-mail', form.elements.namedItem('email').value.trim()]
    ];
    var items = form.elements.namedItem('items').value.trim();
    if (items) rows.push(['Varer', items]);
    return rows;
  }

  function buildSummary(list, form) {
    list.innerHTML = '';
    summaryRows(form).forEach(function (row) {
      var dt = document.createElement('dt');
      dt.textContent = row[0];
      var dd = document.createElement('dd');
      dd.textContent = row[1];
      list.appendChild(dt);
      list.appendChild(dd);
    });
  }

  function mailtoFallback(form) {
    var order = form.elements.namedItem('orderNo').value.trim();
    var name = form.elements.namedItem('name').value.trim();
    var items = form.elements.namedItem('items').value.trim();
    var subject = 'Fortrydelse af ordre ' + (order || '');
    var body =
      'Jeg vil gerne fortryde mit køb.\n\n' +
      'Navn: ' + name + '\n' +
      'Ordrenummer: ' + order + '\n' +
      (items ? 'Varer: ' + items + '\n' : '') +
      '\nSendt fra webshoppens fortrydelsesformular.';
    return 'mailto:' + SUPPORT_MAIL + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
  }

  function init(root) {
    var form = root.querySelector('[data-nv-form]');
    if (!form) return;

    var dialog = root.querySelector('dialog');
    var trigger = root.querySelector('[data-nv-open]');
    var step1 = form.querySelector('[data-nv-step="1"]');
    var step2 = form.querySelector('[data-nv-step="2"]');
    var success = root.querySelector('[data-nv-success]');
    var status = form.querySelector('[data-nv-status]');
    var nextBtn = form.querySelector('[data-nv-next]');
    var confirmBtn = form.querySelector('[data-nv-confirm]');
    var backBtn = form.querySelector('[data-nv-back]');
    var closeButtons = root.querySelectorAll('[data-nv-close]');
    var endpoint = (form.getAttribute('data-endpoint') || '').trim();
    var openedAt = Date.now();
    var previousOverflow = '';
    var lastFocus = null;
    var sending = false;

    function openDialog() {
      if (!dialog) return;
      lastFocus = document.activeElement;
      openedAt = Date.now();
      if (typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
        dialog.classList.add('nv-fortryd__dialog--fallback');
      }
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      var first = step1 && !step1.hidden ? form.elements.namedItem('name') : confirmBtn;
      if (first) {
        window.setTimeout(function () {
          first.focus();
        }, 60);
      }
    }

    function closeDialog() {
      if (!dialog) return;
      if (typeof dialog.close === 'function' && dialog.open) {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
      document.body.style.overflow = previousOverflow || '';
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    if (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        openDialog();
      });
    }

    document.querySelectorAll('[data-nv-fortryd-open]').forEach(function (el) {
      if (el === trigger || el.dataset.nvBound) return;
      el.dataset.nvBound = '1';
      el.addEventListener('click', function (event) {
        event.preventDefault();
        openDialog();
      });
    });

    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (dialog) {
          closeDialog();
        } else {
          form.reset();
          showStep(1);
          if (success) success.hidden = true;
          form.hidden = false;
        }
      });
    });

    if (dialog) {
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) closeDialog();
      });
      dialog.addEventListener('close', function () {
        document.body.style.overflow = previousOverflow || '';
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && dialog && dialog.open) closeDialog();
    });

    function showStep(n) {
      step1.hidden = n !== 1;
      step2.hidden = n !== 2;
      form.dataset.step = String(n);
    }

    function setStatus(message, kind) {
      if (!status) return;
      status.textContent = message || '';
      status.classList.toggle('nv-fortryd__status--error', kind === 'error');
      status.classList.toggle('nv-fortryd__status--success', kind === 'success');
    }

    function showSuccess(ref, email, receivedAt, receiptStatus, duplicate) {
      setStatus('');
      form.hidden = true;
      if (success) {
        success.hidden = false;
        text(success.querySelector('[data-nv-ref]'), ref || '–');
        var msg = success.querySelector('[data-nv-success-text]');
        if (msg) {
          var target = email || 'din e-mail';
          if (duplicate) {
            msg.textContent =
              'Vi har allerede modtaget din fortrydelse af denne ordre. Referencen er ' +
              (ref || '–') +
              '. Skriv til ' +
              SUPPORT_MAIL +
              ', hvis du vil ændre noget.';
          } else if (receiptStatus === 'sent') {
            msg.textContent =
              'Kvitteringen er sendt til ' +
              target +
              (receivedAt ? ' (' + receivedAt + ')' : '') +
              '. Får du den ikke inden for et par minutter, så tjek spam eller skriv til ' +
              SUPPORT_MAIL +
              '.';
          } else {
            msg.textContent =
              'Vi har modtaget din fortrydelse og sender kvitteringen til ' +
              target +
              ' om lidt. Kommer den ikke, så skriv til ' +
              SUPPORT_MAIL +
              '.';
          }
        }
        success.focus();
      }
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (sending) return;

      var step = form.dataset.step || '1';

      if (step === '1') {
        var errors = validate(form);
        if (errors.length) {
          setStatus('Der mangler lidt, før vi kan sende.', 'error');
          errors[0].focus();
          return;
        }
        setStatus('');
        buildSummary(form.querySelector('[data-nv-summary]'), form);
        showStep(2);
        if (confirmBtn) confirmBtn.focus();
        return;
      }

      if (!endpoint) {
        setStatus('Formularen er ikke sat op endnu. Skriv til ' + SUPPORT_MAIL + '.', 'error');
        return;
      }

      var hp = form.elements.namedItem('company');
      var payload = {
        name: form.elements.namedItem('name').value.trim(),
        orderNo: form.elements.namedItem('orderNo').value.trim(),
        email: form.elements.namedItem('email').value.trim(),
        items: form.elements.namedItem('items').value.trim(),
        company: hp ? hp.value : '',
        t: openedAt,
        page: window.location.pathname,
        lang: document.documentElement.lang || 'da'
      };

      sending = true;
      setStatus('Sender …');
      form.setAttribute('aria-busy', 'true');
      if (confirmBtn) {
        confirmBtn.disabled = true;
        confirmBtn.dataset.label = confirmBtn.textContent;
        confirmBtn.textContent = 'Sender …';
      }

      var controller = typeof AbortController === 'function' ? new AbortController() : null;
      var timer = controller
        ? window.setTimeout(function () {
            controller.abort();
          }, 20000)
        : null;

      fetch(endpoint, {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        signal: controller ? controller.signal : undefined
      })
        .then(function (res) {
          return res
            .json()
            .catch(function () {
              return {};
            })
            .then(function (data) {
              return { res: res, data: data };
            });
        })
        .then(function (result) {
          var res = result.res;
          var data = result.data || {};

          if (res.ok && data.ok) {
            showSuccess(data.ref, payload.email, data.received_at, data.receipt, data.duplicate);
            return;
          }

          if (res.status === 400 && data.fields) {
            Object.keys(data.fields).forEach(function (key) {
              var input = form.elements.namedItem(key);
              if (input) setError(input, data.fields[key]);
            });
            showStep(1);
            setStatus('Ret de felter, der er markeret.', 'error');
            var firstBad = form.querySelector('[aria-invalid="true"]');
            if (firstBad) firstBad.focus();
            return;
          }

          if (res.status === 429) {
            setStatus(data.message || 'Du har lige sendt en fortrydelse. Vent et par minutter.', 'error');
            return;
          }

          throw new Error('server');
        })
        .catch(function () {
          setStatus(
            'Vi kunne ikke sende formularen lige nu. Send den i stedet som en mail – den gælder lige så godt.',
            'error'
          );
          if (status && !status.querySelector('a')) {
            var link = document.createElement('a');
            link.href = mailtoFallback(form);
            link.textContent = ' Åbn mail med oplysningerne';
            status.appendChild(link);
          }
        })
        .then(function () {
          sending = false;
          form.removeAttribute('aria-busy');
          if (confirmBtn) {
            confirmBtn.disabled = false;
            confirmBtn.textContent = confirmBtn.dataset.label || 'Bekræft fortrydelse';
          }
          if (timer) window.clearTimeout(timer);
        });
    });

    if (backBtn) {
      backBtn.addEventListener('click', function () {
        setStatus('');
        showStep(1);
        var first = form.elements.namedItem('name');
        if (first) first.focus();
      });
    }

    showStep(1);

    /* Åbn direkte fra link: #fortryd eller ?fortryd=1 */
    if (dialog) {
      var wantsOpen =
        window.location.hash === '#fortryd' ||
        new URLSearchParams(window.location.search).get('fortryd') === '1';
      if (wantsOpen) openDialog();
    }
  }

  function boot() {
    document.querySelectorAll('[data-nv-fortryd]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
